import APP from '../modules/index';

export const navigation = [
  {
    id: 'heading',
    displayLabel: 'Project Setup',
    url: '',
    iconName: 'fa-play-circle-o',
    options: [
      {
        id: 'heading',
        displayLabel: 'Applications Setting',
        url: '',
        iconName: 'fa fa-cog',
        options: [
          {
            id: APP.Constants.ROUTES.VIEW_INTEGRATION,
            displayLabel: '3rd Party Integration',
            url: APP.Constants.ROUTES.VIEW_INTEGRATION,
            iconName: 'fa fa-product-hunt',
            options: []
          }
        ]
      }
    ]
  },
  {
    id: 'heading',
    displayLabel: 'Intelligence',
    url: '',
    iconName: 'fa-cog',
    options: []
  }
];
